/**
 * Hard boundary for the first standalone COYG data store. A request composed
 * by Cannon or an earlier COYG build must never replay into this database.
 */
export const STANDALONE_DATA_EPOCH = 'coyg-standalone-2026-08-24-v1';
